'use client';

import { useState } from 'react';
import { useSession, signIn } from 'next-auth/react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PriceAlertModal } from '@/components/modals/PriceAlertModal';
import { cn } from '@/lib/utils';

interface PriceAlertButtonProps {
  origin: string;
  destination: string;
  originName: string;
  destinationName: string;
  className?: string;
  onAdded?: () => void;
}

export function PriceAlertButton({
  origin,
  destination,
  originName,
  destinationName,
  className,
  onAdded,
}: PriceAlertButtonProps) {
  const { status } = useSession();
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    if (status !== 'authenticated') {
      signIn('google');
      return;
    }
    setIsOpen(true);
  };

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={handleClick}
        className={cn('gap-2', className)}
      >
        <Bell className="w-4 h-4" />
        Hedef Fiyat Belirle
      </Button>

      <PriceAlertModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        origin={origin}
        destination={destination}
        originName={originName}
        destinationName={destinationName}
        onSuccess={onAdded}
      />
    </>
  );
}
